angular.module('console')
.controller('ConsoleController', ['$scope', '$state',
    function($scope, $state){
        $scope.$state = $state;
        $scope.tabsData = [{
            heading: 'Practice',
            route: "console.practice({practice: $state.params.practice, user: $state.params.user, invitation: $state.params.invitation})",
            class: 'glyphicon glyphicon-home',
            active: false
        },
        {
            heading: 'Reports',
            route: 'console.reports',
            class: 'glyphicon glyphicon-list-alt',
            active: false
        }];

        $scope.active = function(route) {
            return $state.is(route);
        };

        // Control active tab index for tabset
        $scope.activeTabIndex = $scope.active('console.reports') ? 1 : 0;

        $scope.$on("$stateChangeSuccess", function() {
            $scope.activeTabIndex = $scope.active('console.reports') ? 1 : 0;
        });
    }]);
